
import { Component, Mixins } from "vue-property-decorator";
import { Point, Vector } from "../../../../../../base/domain/drawing";
import { IVectorPropertyEditable, instanceOfIVectorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class VectorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IVectorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IVectorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isVectorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIVectorPropertyEditable(s) && s.vector().isEditable(), false);
  }

  get vector(): Vector {
    return this.readPropertyOrDefault(s => Vector.from(s.vector().getValue()), new Vector(new Point(0, 0), new Point(0, 0)));
  }

  set vector(value: Vector) {
    this.writePropertyWhenValid(s => s.vector().setValue(Vector.to(value)));
  }
}
